import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { MaintenanceScreen } from '@/screens/accounts/SCR-111-114-info'

// SCR-114 Scheduled maintenance (accounts area).
export const Route = createFileRoute('/_public/maintenance')({
  validateSearch: z.object({ next: z.string().max(2000).optional().catch(undefined) }),
  component: function Maintenance() {
    return <MaintenanceScreen search={Route.useSearch()} />
  },
})
